import React from "react";
import { TARGET_METHODS } from "utils/constants";
import LegacySelection from "./LegacySelection";
import ModernSelection from "./ModernSelection";
import StatSigSelection from "./StatSigSelection";
import SoftmaxSelection from "./SoftmaxSelection";
import PropTypes from "prop-types";

export default function AutoOptimizationModel(props) {
	const {
		currentValue,
		onChange,
		isModernEnabled,
		legacyTargetMethod,
		onLegacyChange,
		onObjective,
		selectedObjective,
		winnerPercentage,
		onWinnerPercentageChange,
		statSigPercentage,
		onStatSigPercentageChange,
		minEvents,
		onMinEventsChange,
		temperature,
		onTemperatureChange,
	} = props;

	const legacy = (
		<LegacySelection
			currentValue={legacyTargetMethod}
			onChange={onLegacyChange}
		/>
	);
	const modern = (
		<ModernSelection
			onChange={onChange}
			currentValue={currentValue}
			onObjective={onObjective}
			selectedObjective={selectedObjective}
		/>
	);
	const statSig = (
		<StatSigSelection
			onObjective={onObjective}
			selectedObjective={selectedObjective}
			winnerPercentage={winnerPercentage}
			onWinnerPercentageChange={onWinnerPercentageChange}
			statSigPercentage={statSigPercentage}
			onStatSigPercentageChange={onStatSigPercentageChange}
			minEvents={minEvents}
			onMinEventsChange={onMinEventsChange}
		/>
	);
	const softmax = (
		<SoftmaxSelection
			onObjective={onObjective}
			selectedObjective={selectedObjective}
			temperature={temperature}
			onTemperatureChange={onTemperatureChange}
		/>
	);

	const modelsWithModernEnabled = {
		[TARGET_METHODS.LEGACY]: legacy,
		[TARGET_METHODS.MODERN]: modern,
		[TARGET_METHODS.MODERN_AUDIENCE]: modern,
		[TARGET_METHODS.STATISTICAL_SIGNIFICANCE]: statSig,
		[TARGET_METHODS.SOFTMAX]: softmax,
	};

	if (isModernEnabled) {
		return modelsWithModernEnabled[currentValue] || null;
	}
	return legacy;
}

AutoOptimizationModel.propTypes = {
	currentValue: PropTypes.string,
	onChange: PropTypes.func,
	isModernEnabled:PropTypes.bool,
	legacyTargetMethod: PropTypes.string,
	onLegacyChange: PropTypes.func,
	onObjective: PropTypes.func,
	selectedObjective: PropTypes.shape({
		value: PropTypes.shape({
			id: PropTypes.number,
			name: PropTypes.string,
		}),
		label: PropTypes.string,
	}),
	winnerPercentage: PropTypes.number,
	onWinnerPercentageChange: PropTypes.func,
	statSigPercentage: PropTypes.number,
	onStatSigPercentageChange: PropTypes.func,
	minEvents: PropTypes.number,
	onMinEventsChange: PropTypes.func,
	temperature: PropTypes.string,
	onTemperatureChange: PropTypes.func,
};
